import {
    SET_PLOTLY_CLICK_DATA,
} from '../../actions';

const initialState = {
    data: {}
}

function plotlyClickReducer(state = initialState, action ) {
    const newState = {};

    switch (action.type) {
        case SET_PLOTLY_CLICK_DATA:
            newState.data = action.data;
            return newState;

        default:
            return state;
    }
}

export default plotlyClickReducer;
